import React from "react";
import {
  ModalButtonsContainer,
  TextButton,
  TextInput,
} from "@SeemplicityDev/shared";

export interface EditScopeDetailsProps {
  name: string;
  onNameChange: (name: string) => void;
  collisionError?: string;
  saveDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const EditScopeDetails: React.FC<EditScopeDetailsProps> = ({
  name,
  onNameChange,
  collisionError,
  saveDisabled = false,
  onConfirm,
  onCancel,
}) => (
  <div className={"modal-text"} data-testid={"edit-scope-details"}>
    <TextInput
      data-testid={"scope-name"}
      label={"Name"}
      labelTop
      required
      value={name}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onNameChange(e.target.value)
      }
      error={collisionError ? { message: collisionError } : null}
      placeholder={"Scope Name"}
    />
    <ModalButtonsContainer>
      <TextButton
        buttonStyle={"secondary"}
        label={"Cancel"}
        onClick={onCancel}
        data-testid={"cancel-edit-scope-details"}
      />
      <TextButton
        buttonStyle={"primary"}
        label={"Save"}
        onClick={onConfirm}
        disabled={saveDisabled || !!collisionError || !name.trim()}
        data-testid={"save-scope-details"}
      />
    </ModalButtonsContainer>
  </div>
);

export default EditScopeDetails;
